import React from "react";
import { Button, Typography } from "@mui/material";

interface LevelTabInterface {
  label: string;
  onPress: (level: string) => void;
  value: string;
  current: string;
  index: number;
  totalTabs: number;
}

const LevelTab: React.FC<LevelTabInterface> = ({
  label,
  value,
  index,
  onPress,
  totalTabs,
  current,
}) => {
  return (
    <Button
      onClick={() => {
        onPress(value);
      }}
      sx={{
        padding: "0px 32px",
        borderRight: index + 1 === totalTabs ? "none" : "1px solid white",
        borderRadius: 0,
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
        "&.MuiButtonBase-root:hover": {
          backgroundColor: "transparent",
        },
      }}
    >
      <Typography
        sx={{
          fontSize: "32px",
          fontWeight: "700",
          textAlign: "center",
          borderBottom: current === value ? "2px solid #FED301" : "none",
          color: current === value ? "#FED301" : "white",
        }}
      >
        {label}
      </Typography>
    </Button>
  );
};

export default LevelTab;
